import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function getTLD() {
  const url = new URL(window.location.href);

  return url.hostname.split('.').slice(-2).join('.');
}
